<template>
  <div :class="name">
    <div :class="`${name}__header`">
      <skeleton-basic width="204px" height="22px" style="margin-bottom: 10px;" />
      <skeleton-basic v-for="i in adTypeListCounts" :key="i" :class="`${name}__type`" height="14px" width="204px" />
    </div>
    <div :class="`${name}__listContent`">
      <div :class="`${name}__listContent-item`">
        <div :class="`${name}__listContent-item-content`">
          <skeleton-basic width="70px" height="70px" :class="`${name}__listContent-item-pic`"></skeleton-basic>
          <div>
            <skeleton-basic :class="`${name}__listContent-item-text`" height="12px" width="22px" />
            <skeleton-basic :class="`${name}__listContent-item-text`" height="12px" width="112px" />
            <skeleton-basic :class="`${name}__listContent-item-text`" height="12px" width="112px" />
          </div>
        </div>
        <div :class="`${name}__listContent-item-button`">
          <skeleton-basic height="14px" width="54px" />
        </div>
      </div>
    </div>
    <div :class="`${name}__footer`">
      <skeleton-basic height="34px" width="68px" style="border-radius: 4px;" />
    </div>
  </div>
</template>
<script>
import { defineComponent } from '@vue/composition-api';
import SkeletonBasic from '@/components/skeleton/basic.vue';

const name = 'ttam-creative-right-side-bar-skeleton';
export default defineComponent({
  name,
  components: {
    SkeletonBasic,
  },
  setup() {
    const adTypeListCounts = 5;
    return {
      name,
      adTypeListCounts,
    };
  },
});
</script>

<style lang="scss">
$name: 'ttam-creative-right-side-bar-skeleton';
.#{$name} {
  &__header {
    line-height: 22;
    padding: 14px 18px;
    background-color: #fff;
    border-bottom: 1px solid #ebebeb;
  }
  &__type {
    margin-bottom: 6px;
  }
  &__listContent {
    padding: 9px 16px 9px 8px;
    overflow: auto;
    background: #f8f8f8;
    &-item {
      margin-bottom: 8px;
      padding: 10px 10px 7px 10px;
      background: #ffffff;
      border-left: 3px solid transparent;
      border-radius: 2px;
      border-left-color: #f60457;
      &-content {
        display: flex;
      }
      &-pic {
        margin-right: 12px;
      }
      &-text {
        margin-bottom: 4px;
      }
      &-button {
        margin-top: 10px;
        margin-bottom: 8px;
        display: flex;
        justify-content: center;
      }
    }
  }
  &__footer {
    padding: 10px;
    display: flex;
    justify-content: center;
    background-color: #fff;
    border-top: 1px solid #ebebeb;
  }
}
</style>
